import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { QuestionBankFormValues } from "src/models/QuestionBank.model";
import QuestionBankForm from "../Layouts/QuestionBankForm";
import {
  useEditQuestionsMutation,
  useGetQuestionsByIdQuery,
} from "src/services/QuestionBankServices";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
type Props = {
  onClose: () => void;
  questionId: string;
};

const EditQuestionBankFormWrapper = ({ onClose, questionId }: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);
  const [questionData, setQuestionData] = useState<any>({});

  const [editQuestion] = useEditQuestionsMutation();
  const { data, isLoading, isFetching } = useGetQuestionsByIdQuery({
    id: questionId,
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setQuestionData(data?.data?.[0]);
    }
  }, [data, isLoading, isFetching]);

  // Form Initial Values
  const initialValues: QuestionBankFormValues = {
    question: questionData?.question || "",
    hintVideoUrl : questionData?.hintVideoUrl || '',
    tagId: questionData?.tags || [],
    title: questionData?.title || "",
    complexity:
      {
        label: questionData?.complexity,
        value: questionData?.complexity,
      } || "",
    order: questionData?.order,
    explanationVideoURL: questionData?.explanationVideoUrl || "",
    solution: questionData?.solution || "",
    solutionVideoURL: questionData?.solutionVideoUrl || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    question: string().required("Please enter question"),
    title: string().required("Please enter title"),
  });

  // Handle Submit
  const handleSubmit = (
    values: QuestionBankFormValues,
    { setSubmitting, resetForm }: FormikHelpers<QuestionBankFormValues>
  ) => {
    const formatedValue = {
      question: values?.question,
      tags: values?.tagId,
      title: values?.title,
      complexity: values?.complexity?.value,
      order: values?.order,
      explanationVideoUrl: values?.explanationVideoURL,
      solution: values?.solution,
      solutionVideoUrl: values?.solutionVideoURL,
    };
    editQuestion({
      body: formatedValue,
      id: questionId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xl" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <QuestionBankForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Edit"
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditQuestionBankFormWrapper;
